import { toast } from "sonner";
/**
 * Clipboard helpers shared across Chat.jsx, StaffSheetsModal, Wallet, LPG
 * report, etc. Kept as a tiny standalone lib so extracted components can
 * import it without pulling in the full Chat.jsx surface.
 */

export async function copyForSpreadsheet(rows) {
  // rows: array of arrays of strings — each inner array = one row
  const plain = rows.map((r) => r.join("\t")).join("\n");
  const html =
    "<table>" +
    rows
      .map(
        (r) =>
          "<tr>" +
          r
            .map(
              (c) =>
                // mso-number-format forces Excel to treat the cell as text
                `<td style="mso-number-format:'\\@';">${String(c).replace(/&/g, "&amp;").replace(/</g, "&lt;")}</td>`
            )
            .join("") +
          "</tr>"
      )
      .join("") +
    "</table>";
  try {
    if (navigator.clipboard && window.ClipboardItem && window.isSecureContext) {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([plain], { type: "text/plain" }),
        }),
      ]);
      return true;
    }
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(plain);
      return true;
    }
  } catch (_e) {
    // Fall through to textarea fallback below — clipboard API errors are
    // common in insecure iframes and stale-permission situations. Not a
    // user-facing failure yet.
    console.debug("clipboard.write threw; falling back:", _e);
  }
  // Last-resort textarea fallback
  try {
    const ta = document.createElement("textarea");
    ta.value = plain;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    return true;
  } catch (_e) {
    console.error("copyForSpreadsheet fallback failed:", _e);
    return false;
  }
}


// Digits-only clipboard helper — trims non-digits, caps at 17 chars (max
// LPG ID length). Returns the copied string or null on failure. Used by
// CopyChip and other one-shot copy targets.

export function copyDigits(raw) {
  const digits = String(raw || "").replace(/\D/g, "").slice(0, 17);
  if (!digits) return null;
  try {
    navigator.clipboard.writeText(digits);
    toast.success(`Copied · ${digits}`, { duration: 1200 });
    return digits;
  } catch (_e) {
    // Clipboard denied (insecure context, permission) — silent so we
    // don't spam toasts on old browsers. Debug log helps track cause.
    console.debug("copyDigits: clipboard.writeText threw:", _e);
    return null;
  }
}
